import { Fragment, useEffect, useState } from 'react';
import { Fab, useTheme, useMediaQuery } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';

import PrimaryButton from '../ui/buttons/primaryButton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { getEvent } from '../../features/event/eventSlice';
import { createGame } from '../../features/game/gameSlice';

import AddIcon from '@mui/icons-material/Add';
import { useParams } from 'react-router-dom';
import AddGameDialogAlt from './addGameDialogAlt';

const schema = yup.object().shape({
  teamA: yup.string().required('Team A is required'),
  teamB: yup.string().required('Team B is required'),
  teamAColor: yup.string(),
  teamBColor: yup.string(),
  teams: yup.object().required('Teams are required'),
  round: yup.number(),
  rink: yup.number(),
  green: yup.string(),
  live: yup.boolean(),
  featured: yup.boolean()
});

const AddGameDialog = ({
  section,
  game,
  fab,
  teamAId,
  teamBId,
  customName,
  bracketId,
  matchId,
  buttonStyle
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const event = useSelector((state) => state.event.event);
  const selectedVenue = useSelector((state) => state.venue.selectedVenue);
  const [gameFormat, setGameFormat] = useState(event?.gameFormat);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const methods = useForm({
    resolver: yupResolver(schema)
  });

  const errors = methods.formState.errors;

  const eventId = useParams().eventId;

  useEffect(() => {
    if (event === undefined && eventId) {
      dispatch(getEvent(eventId));
    }
  }, [event, eventId, dispatch]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createGameName = (data) => {
    let gameFormat = event.gameFormat;
    let gameName = '';

    if (event.venue && data.green !== 'na') {
      gameName = gameName + `${data.green}${data.rink}`;
    }

    if (gameFormat.sections > 0 && section) {
      gameName = gameName + ` - ${section.name}`;
    }

    if (gameFormat.rounds > 0) {
      gameName = gameName + ` - Round ${data.round}`;
    }

    return gameName;
  };

  const onSubmit = async (data) => {
    let gameName = createGameName(data);
    data.name = gameName;

    if (customName) {
      data.name = customName;
    }

    if (event) {
      data.event = event.id;
      data.gameFormat = gameFormat;
      data.gameType = gameFormat.gameType;
      data.venue = event.venue.id;
    }

    if (section) {
      data.section = section.id;
    }

    if (bracketId && matchId) {
      data.bracket = bracketId;
      data.match = matchId;
    }

    dispatch(createGame(data))
      .unwrap()
      .then(() => {
        setOpen(false);
        methods.reset();
      })
      .catch((err) => {});
  };

  const onAdd = async () => {
    methods.handleSubmit(onSubmit)();
  };

  return (
    <Fragment>
      {!fab ? (
        <PrimaryButton
          sx={buttonStyle}
          size={'small'}
          variant={'contained'}
          onClick={() => handleClickOpen()}
          onTouchStart={() => handleClickOpen()}>
          Add Game
        </PrimaryButton>
      ) : (
        <Fab color="primary" aria-label="add" onClick={() => handleClickOpen()}>
          <AddIcon />
        </Fab>
      )}

      <AddGameDialogAlt
        section={section}
        teamAId={teamAId}
        teamBId={teamBId}
        customName={customName}
        bracketId={bracketId}
        matchId={matchId}
        event={event}
        open={open}
        onClose={handleClose}
      />
    </Fragment>
  );
};

export default AddGameDialog;
